export const MESSAGE_BUILDER_MOBILE_BREAKPOINT = "xl";
